export enum SubscriptionsFiltersFields {
  EMAIL = 'email',
  DATE_FROM = 'date_from',
  DATE_TO = 'date_to',
}

export type TGetSubscriptionsQuery = {
  [SubscriptionsFiltersFields.EMAIL]?: string;
  [SubscriptionsFiltersFields.DATE_FROM]?: string;
  [SubscriptionsFiltersFields.DATE_TO]?: string;
};
